import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Text } from '@eneco/sparky';
import { wrap } from '@sitecore/common';
import type { ContentCardRendering } from '@sitecore/types/manual/ContentCard';

type ContentField = ContentCardRendering['fields']['content'];

/** Shared body copy used by ContentCard and campaign variants. */
export const ContentCardBodyText: FC<{ content?: ContentField }> = ({ content }) => {
  if (!content?.value) return null;

  return <Text size={{ initial: 'BodyM', md: 'BodyL' }}>{wrap(content, <RichText html={content.value} />)}</Text>;
};

export const FlatContentCardBodyText: FC<{ content?: string }> = ({ content }) => {
  if (!content) return null;

  return (
    <Text size={{ initial: 'BodyM', md: 'BodyL' }}>
      <RichText html={content} />
    </Text>
  );
};
